// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.16406 3.33027H5.66406C4.26393 3.33027 3.56387 3.33027 3.02909 3.60275C2.55868 3.84244 2.17623 4.22489 1.93655 4.69529C1.66406 5.23007 1.66406 5.93014 1.66406 7.33027V14.3303C1.66406 15.7304 1.66406 16.4305 1.93655 16.9652C2.17623 17.4356 2.55868 17.8181 3.02909 18.0578C3.56387 18.3303 4.26393 18.3303 5.66406 18.3303H12.6641C14.0642 18.3303 14.7643 18.3303 15.299 18.0578C15.7694 17.8181 16.1519 17.4356 16.3916 16.9652C16.6641 16.4305 16.6641 15.7304 16.6641 14.3303V10.8303M6.66404 13.3303H8.05949C8.46714 13.3303 8.67097 13.3303 8.86278 13.2842C9.03284 13.2434 9.19542 13.176 9.34454 13.0847C9.51273 12.9816 9.65686 12.8375 9.94511 12.5492L17.9141 4.58027C18.6044 3.88991 18.6044 2.77062 17.9141 2.08027C17.2237 1.38991 16.1044 1.38991 15.4141 2.08027L7.44509 10.0492C7.15684 10.3375 7.01271 10.4816 6.90964 10.6498C6.81826 10.7989 6.75092 10.9615 6.71009 11.1315C6.66404 11.3234 6.66404 11.5272 6.66404 11.9348V13.3303Z"
    />
  </svg>
);
const IconEditPencilOutline = forwardRef(
  (props: Omit<IconProps, 'icon'>, ref) => {
    return <Icon ref={ref} icon={Svg} {...props} />;
  }
);
export default IconEditPencilOutline;
